export default __webpack_public_path__ + "static/media/huma-tresfases-cover.f85b2e75.jpg";